"use client";

import { c as _c } from "react/compiler-runtime";
import { useUserSummary } from "@/lib/api/user";
import { TriangleAlert } from "lucide-react";

/**
 * A loud, unmissable banner shown whenever the backend reports an active
 * automated test run (`summary.test_run`, set via `POST /api/test/run`). It
 * makes it obvious that the current environment is under test and its data may
 * be wiped at any moment.
 *
 * This can only ever appear in non-production deployments: the backend refuses
 * to open a test run when `HA_DEPLOYMENT_ENV=prod`, so `test_run` is always
 * `null` there. The text is intentionally hardcoded (German) — it is never seen
 * by real users, so it is excluded from the translation catalog.
 */
export default function TestModeBanner() {
  const $ = _c(4);
  const {
    data: summary
  } = useUserSummary();
  const runId = summary?.test_run;
  if (!runId) {
    return null;
  }
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <TriangleAlert className="h-4 w-4 shrink-0" aria-hidden={true} />;
    t1 = <span>Testmodus aktiv – diese Umgebung wird automatisiert getestet. Daten können jederzeit gelöscht werden.</span>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== runId) {
    t2 = <div role="alert" data-testid="test-mode-banner" className="sticky top-0 z-50 -mx-2 flex items-center justify-center gap-2 bg-yellow-400 px-4 py-1.5 text-center text-sm font-semibold text-yellow-950 shadow">{t0}{t1}<span className="font-mono text-xs opacity-70">({runId})</span></div>;
    $[2] = runId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}